module.exports = __webpack_public_path__ + "img/ad.5a749df5.png";